import React, {useRef, useState} from 'react';
import Webcam from "react-webcam";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faMinus, faCircle, faEraser, faCamera} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import {useStores} from "../../../../stores/Context";
import {useParams} from "react-router-dom";
import BtnSvg from "../../../../boiteAOutils/BtnSvg";


const WidgetConsignesContentPhotoCamera = () => {
    const {widgetStore} = useStores();
    const {id, ent} = useParams();
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + widgetStore.getCookie("current_apiToken");

    const handleSaveImg = () => {
        const context = document.getElementById("canvas");
        let img = context.toDataURL('image/png');

        if (img){
            axios.post(process.env.REACT_APP_API_URL + '/api/addNewPhoto', {
                img: img,
                id_totem: widgetStore.idTotem
            }).then(() => {
                setImgSvg(null);
                setShowCanvas(false);
            })
        }

    }


    const webcamRef = React.useRef(null);
    const [imgSvg, setImgSvg] = useState(null);
    const canvasRef = useRef(null);
    const [showCanvas, setShowCanvas] = useState(false);


    const capture = React.useCallback(
        () => {
            setShowCanvas(true);
            const imageSrc = webcamRef.current.getScreenshot();
            setImgSvg(imageSrc)
            const context = canvasRef.current.getContext('2d');
            let image = new Image();
                image.src = imageSrc
                image.onload = function() {
                    context.drawImage(image, 0, 0);
                };
        },
        [webcamRef]
    );


    const videoConstraints = {
        width: 1000,
        height: 1500,
       // facingMode: { exact: "environment" }
    };


    const [brushSize, setBrushSize] = useState(5);
    const [brushColor, setBrushColor] = useState('black');
    const [previousX, setPreviousX] = useState(0);
    const [previousY, setPreviousY] = useState(0);
    const [isDrawing, setIsDrawing] = useState(false);

    const newPhoto = () => {
      setImgSvg(null);
      setShowCanvas(false);
    }
    const handleMouseDown = (event) => {
        setIsDrawing(true);
        setPreviousX(event.clientX);
        setPreviousY(event.clientY);
    };

    const handleTouchStart = (event) => {
        setIsDrawing(true);
        const touch = event.touches[0];
        setPreviousX(touch.clientX);
        setPreviousY(touch.clientY);
    };

    const handleMouseUp = () => {
        setIsDrawing(false);
    };

    const handleTouchEnd = () => {
        setIsDrawing(false);
    };

    const handleMouseMove = (event) => {
        if (!isDrawing) {
            return;
        }

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.lineWidth = brushSize;
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.strokeStyle = brushColor;
        ctx.beginPath();
        ctx.moveTo(previousX, previousY);
        ctx.lineTo(event.clientX, event.clientY);
        ctx.stroke();
        setPreviousX(event.clientX);
        setPreviousY(event.clientY);
    };

    const handleTouchMove = (event) => {
        if (!isDrawing) {
            return;
        }

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.lineWidth = brushSize;
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.strokeStyle = brushColor;
        const touch = event.touches[0];
        ctx.beginPath();
        ctx.moveTo(previousX, previousY);
        ctx.lineTo(touch.clientX, touch.clientY);
        ctx.stroke();
        setPreviousX(touch.clientX);
        setPreviousY(touch.clientY);
    };

    const handleClickErase = () => {
        const context = canvasRef.current.getContext('2d');
        let image = new Image();
        image.src = imgSvg
        context.drawImage(image, 0, 0);
    }

    return (
        <div>



            {

                    <div className={`${ showCanvas ?  "webcamContent" : "hideCanvas" }`}>
                        <canvas
                            ref={canvasRef}
                            id={"canvas"}
                            className={"canvasPhoto"}
                            onMouseDown={handleMouseDown}
                            onMouseUp={handleMouseUp}
                            onMouseMove={handleMouseMove}
                            onTouchStart={handleTouchStart}
                            onTouchEnd={handleTouchEnd}
                            onTouchMove={handleTouchMove}
                            width={750}
                            height={500}
                        />
                    </div>

            }

            {
                imgSvg ? (
                    <div className={"webcamContent"}>
                        <div className={"annotPhotoBarre"}>
                            <div className={"annotPhotoColors"}>
                                <a href="#" data-couleur="#000000" style={{backgroundColor: "#000000"}} onClick={() => {setBrushColor('#000000')}} >Noir</a>
                                <a href="#" data-couleur="#ff0000" style={{backgroundColor: "#ff0000"}} onClick={() => {setBrushColor('#ff0000')}}>Rouge</a>
                                <a href="#" data-couleur="green" style={{backgroundColor: "green"}} onClick={() => {setBrushColor('green')}}>Vert</a>
                                <a href="#" data-couleur="blue" style={{backgroundColor: "blue"}} onClick={() => {setBrushColor('blue')}}>Bleu</a>
                                <a href="#" data-couleur="orange" style={{backgroundColor: "orange"}} onClick={() => {setBrushColor('orange')}}>orange</a>
                                <a href="#" data-couleur="purple" style={{backgroundColor: "purple"}} onClick={() => {setBrushColor('purple')}}>purple</a>
                            </div>
                            <div className={"annotPhotoWidth"}>
                                <FontAwesomeIcon icon={faMinus} onClick={() => {setBrushSize(brushSize-1)}} />
                                <span>
                                <FontAwesomeIcon icon={faCircle} style={{fontSize: (5+brushSize)+"px"}}/>
                            </span>
                                <FontAwesomeIcon icon={faPlus} onClick={() => {setBrushSize(brushSize+1)}}/>
                            </div>
                            <div className={"annotPhotoReset"} >
                                <FontAwesomeIcon icon={faEraser} onClick={() => handleClickErase()}/>
                            </div>
                        </div>
                        <div className={"btnSaveImgContent"}>
                            <button className={"btnMenuPhoto"} onClick={handleSaveImg} style={{backgroundColor: "#108010"}}>Enregistrer la photo</button>
                            <button className={"btnMenuPhoto"} onClick={newPhoto} style={{backgroundColor: "#707070"}}>Nouvelle photo</button>
                        </div>
                    </div>

                ) : (
                    <div className={"webcamContent"} >
                        <Webcam
                            audio={false}
                            height={videoConstraints.height}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width={videoConstraints.width}
                            videoConstraints={videoConstraints}
                        />
                        <button className={"btnMenuPhoto"} onClick={capture} style={{marginTop: '3em', backgroundColor: "#1976d2", width: "25%"}}>
                            <FontAwesomeIcon icon={faCamera} style={{fontSize: "2em", marginRight: "0.5em"}} />
                            Prendre une photo
                        </button>
                    </div>
                )
            }
        </div>
    );
};

export default WidgetConsignesContentPhotoCamera;